import type { ISchema } from '../../@types'
import { IdentsOverrideId } from '@/helpers/identsOverrideIds'

// +20% premium products for male (plan-m base). Male shares the female base ladder (intro
// 5.19/9.99/19.99, renewal 44/79), so the same +20% products from DEV-32489 apply: intro
// 6.23/11.99/23.99. Male has no fallback flow (base fallback = null), so premium override mirrors that.
// TODO(GT-4496): DEV-32489 lists female only — confirm with Kasya that male reuses these +20% ids.
import simple_premium_1w_6_23_4w_44_usd from '@/data/products/subscription/prd_wdbH1H1BwzTW'
import simple_premium_4w_11_99_4w_44_usd from '@/data/products/subscription/prd_X629uKPekWOy'
import simple_premium_12w_23_99_12w_79_usd from '@/data/products/subscription/prd_W8yFM8xcgJn2'

// Sets only the +20% premium override (ML_PRICE_PREMIUM_TRAFFIC_WTP), gated on traffic-source WTP.
// Control's ML_PRICE_DISCOUNT arm is NOT carried over. Male ladder has no fallback flow
// (base fallback = null), so the premium override mirrors that.
export default (schema: ISchema): ISchema => {
	const products = schema.config?.products
	if (!products) return schema

	const premiumOverrides = [
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM_TRAFFIC_WTP,
			discounted: simple_premium_1w_6_23_4w_44_usd.ident,
			fallback: null,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM_TRAFFIC_WTP,
			discounted: simple_premium_4w_11_99_4w_44_usd.ident,
			fallback: null,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM_TRAFFIC_WTP,
			discounted: simple_premium_12w_23_99_12w_79_usd.ident,
			fallback: null,
		},
	]

	const updatedProducts = products.map((product, index) => ({
		...product,
		identsOverride: [premiumOverrides[index]],
	}))

	return { ...schema, config: { ...schema.config, products: updatedProducts } }
}
